import type { ReactNode } from 'react';
import React from 'react';
import { Tooltip as AntdTooltip } from 'antd';
import { useIntl } from 'react-intl';
import type { TooltipPlacement } from 'antd/lib/tooltip';
import isString from 'lodash/isString';
import styled from 'types/theme.types';

export type TooltipProps = {
  title?: string | ReactNode | (() => ReactNode);
  titleId?: string;
  titleValues?: Record<string, any>;
  placement: TooltipPlacement;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  children?: ReactNode;
};

const Tooltip: React.FunctionComponent<TooltipProps> = ({
  title,
  titleId,
  children,
  placement,
  titleValues,
  open,
  onOpenChange
}) => {
  const intl = useIntl();

  const antdTitle = titleId ? intl.formatMessage({ id: titleId }, titleValues) : (title ?? '');

  const formattedTitle = antdTitle && isString(antdTitle) ? <StyledTooltip>{antdTitle}</StyledTooltip> : antdTitle;

  return (
    <AntdTooltip
      overlayStyle={{ wordBreak: 'break-word', maxWidth: '320px' }}
      title={formattedTitle}
      placement={placement}
      open={open}
      onOpenChange={onOpenChange}>
      {children}
    </AntdTooltip>
  );
};

export default Tooltip;

const StyledTooltip = styled.div`
  max-height: 360px;
  overflow-y: auto;
  white-space: pre-wrap;
`;
